import React, { useCallback, useState } from "react";
import { connect } from "react-redux";

import Button from "antd/es/button";
import { defineMessages, useIntl } from "react-intl";

import Address from "@mapmycustomers/shared/types/Address";
import { isEmptyString } from "@mapmycustomers/shared/util/stringUtils";
import { SearchField } from "@mapmycustomers/ui";

import AreaSearchMode from "@app/enum/AreaSearchMode";
import { getLeadFinderAddress, getLeadFinderMode } from "@app/scene/map/store/leadFinder/selectors";
import { RootState } from "@app/store/rootReducer";
import useAnalytics from "@app/util/contexts/useAnalytics";

interface Props {
  address?: Address;
  mode: AreaSearchMode;
  onSearch: (value: string) => void;
  query?: string;
}

const messages = defineMessages({
  goButton: {
    id: "map.tool.leadFinder.popover.searchBox.goButton",
    defaultMessage: "Go",
    description: "Lead Finder search box Go button title",
  },
  placeholder: {
    id: "map.tool.leadFinder.popover.searchBox.placeholder",
    defaultMessage: "Enter a keyword or phrase like “Hospitals near me”",
    description: "Lead Finder search box placeholder text",
  },
});

const SearchBox: React.FC<Props> = ({ address, mode, onSearch, query }) => {
  const analytics = useAnalytics();
  const intl = useIntl();
  const [value, setValue] = useState<string>(query ?? "");

  const isValid = !isEmptyString(value) && (mode === AreaSearchMode.ADDRESS ? !!address : true);
  const handleSearch = useCallback(() => {
    if (isValid) {
      onSearch(value);
      analytics.clicked(["Search", "Go"]);
    }
  }, [analytics, isValid, onSearch, value]);

  return (
    <SearchField
      autoFocus
      enterButton={
        <Button disabled={!isValid} type="primary">
          {intl.formatMessage(messages.goButton)}
        </Button>
      }
      onChange={setValue}
      onSearch={handleSearch}
      placeholder={intl.formatMessage(messages.placeholder)}
      showEnterButton
      size="large"
      value={value}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  address: getLeadFinderAddress(state),
  mode: getLeadFinderMode(state),
});

export default connect(mapStateToProps)(SearchBox);
